<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h1 class="contentsHead" style="text-indent: 0%; text-align: center;"><span class="bold">CONTENTS</span></h1>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_title001" title="Link target outside of Sample">TITLE PAGE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ded001" title="Link target outside of Sample">DEDICATION</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/e9780545578011_fm002">SPARK MACHINE</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/e9780545578011_ch001">CHAPTER ONE</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/e9780545578011_ch002">CHAPTER TWO</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/e9780545578011_ch003">CHAPTER THREE</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/e9780545578011_ch004">CHAPTER FOUR</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch005" title="Link target outside of Sample">CHAPTER FIVE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch006" title="Link target outside of Sample">CHAPTER SIX</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch007" title="Link target outside of Sample">CHAPTER SEVEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch008" title="Link target outside of Sample">CHAPTER EIGHT</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch009" title="Link target outside of Sample">CHAPTER NINE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch010" title="Link target outside of Sample">CHAPTER TEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch011" title="Link target outside of Sample">CHAPTER ELEVEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch012" title="Link target outside of Sample">CHAPTER TWELVE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch013" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch014" title="Link target outside of Sample">CHAPTER FOURTEEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch015" title="Link target outside of Sample">CHAPTER FIFTEEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch016" title="Link target outside of Sample">CHAPTER SIXTEEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch017" title="Link target outside of Sample">CHAPTER SEVENTEEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch018" title="Link target outside of Sample">CHAPTER EIGHTEEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch019" title="Link target outside of Sample">CHAPTER NINETEEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch020" title="Link target outside of Sample">CHAPTER TWENTY</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch021" title="Link target outside of Sample">CHAPTER TWENTY-ONE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch022" title="Link target outside of Sample">CHAPTER TWENTY-TWO</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch023" title="Link target outside of Sample">CHAPTER TWENTY-THREE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch024" title="Link target outside of Sample">CHAPTER TWENTY-FOUR</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch025" title="Link target outside of Sample">CHAPTER TWENTY-FIVE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch026" title="Link target outside of Sample">CHAPTER TWENTY-SIX</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch027" title="Link target outside of Sample">CHAPTER TWENTY-SEVEN</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch028" title="Link target outside of Sample">CHAPTER TWENTY-EIGHT</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch029" title="Link target outside of Sample">CHAPTER TWENTY-NINE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch030" title="Link target outside of Sample">CHAPTER THIRTY</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ch031" title="Link target outside of Sample">CHAPTER THIRTY-ONE</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_app001" title="Link target outside of Sample">AUTHOR’S NOTE</span></p>
</div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ack001" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_ata001" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_bm003" title="Link target outside of Sample">PRAISE</span></p>
</div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_fm001" title="Link target outside of Sample">ALSO AVALIABLE</span></p>
</div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/e9780545578011_copy001" title="Link target outside of Sample">COPYRIGHT</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545578011_toc001.vue?7833ac7e